import { useCallback } from 'react'

import type { ToastMessage } from '~/hooks/useSuccessToast'
import { appToaster } from '~/libs/toaster'

/**
 * エラー toast を表示する hook (`docs/guides/frontend-coding-guide.yaml` の
 * `useErrorToast()`)。 設計判断は `~/hooks/useSuccessToast.ts` と共通 (メッセージ
 * 引数の形 / useCallback 化の理由はそちらの JSDoc を参照)。
 */
export function useErrorToast(): (message: ToastMessage) => void {
  return useCallback((message: ToastMessage) => {
    // `closable` を既定 true にする理由と opt-out の条件は
    // `~/hooks/useSuccessToast.ts` の同じ箇所が正 (本 hook は設計判断を
    // そちらへ参照させる構成。 上の JSDoc と同じ扱い)。
    appToaster.create({ closable: true, type: 'error', ...message })
  }, [])
}
